import React from 'react';
import { Wrench, Clock, Mail, RefreshCw } from 'lucide-react';

const MaintenanceScreen = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-medical-50 via-white to-medical-100 dark:from-slate-950 dark:via-slate-900 dark:to-medical-950 flex items-center justify-center px-4">
      {/* Decorative background circles */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute -top-40 -right-40 w-96 h-96 bg-medical-200 dark:bg-medical-900 rounded-full opacity-30 blur-3xl" />
        <div className="absolute -bottom-40 -left-40 w-96 h-96 bg-medical-300 dark:bg-medical-800 rounded-full opacity-20 blur-3xl" />
      </div>

      <div className="relative z-10 max-w-lg w-full text-center">
        {/* Logo / Brand */}
        <div className="mb-8">
          <div className="inline-flex items-center justify-center w-20 h-20 rounded-2xl bg-medical-600 dark:bg-medical-700 shadow-lg mb-4">
            <Wrench className="w-10 h-10 text-white animate-pulse" />
          </div>
          <p className="text-medical-600 dark:text-medical-400 font-semibold text-sm tracking-widest uppercase">
            American Journal of Modern Medicine
          </p>
        </div>

        {/* Main Card */}
        <div className="bg-white dark:bg-slate-800 rounded-2xl shadow-xl border border-medical-100 dark:border-slate-700 px-8 py-10">
          <h1 className="text-3xl font-bold text-slate-800 dark:text-white mb-3">
            Under Maintenance
          </h1>
          <p className="text-slate-500 dark:text-slate-400 text-base leading-relaxed mb-8">
            We're currently performing scheduled maintenance to improve your experience.
            The system will be back online shortly. We apologize for any inconvenience.
          </p>

          {/* Status Items */}
          <div className="space-y-3 mb-8">
            <div className="flex items-center gap-3 bg-medical-50 dark:bg-slate-700 rounded-xl px-4 py-3">
              <Clock className="w-5 h-5 text-medical-600 dark:text-medical-400 flex-shrink-0" />
              <span className="text-sm text-slate-600 dark:text-slate-300">
                Estimated downtime: <span className="font-semibold text-slate-800 dark:text-white">A few hours</span>
              </span>
            </div>
            <div className="flex items-center gap-3 bg-medical-50 dark:bg-slate-700 rounded-xl px-4 py-3">
              <RefreshCw className="w-5 h-5 text-medical-600 dark:text-medical-400 flex-shrink-0" />
              <span className="text-sm text-slate-600 dark:text-slate-300">
                Status: <span className="font-semibold text-amber-500">Maintenance in progress</span>
              </span>
            </div>
            <div className="flex items-center gap-3 bg-medical-50 dark:bg-slate-700 rounded-xl px-4 py-3">
              <Mail className="w-5 h-5 text-medical-600 dark:text-medical-400 flex-shrink-0" />
              <span className="text-sm text-slate-600 dark:text-slate-300">
                Contact:{' '}
                <a
                  href="mailto:support@ajmm.org"
                  className="font-semibold text-medical-600 dark:text-medical-400 hover:underline"
                >
                  support@ajmm.org
                </a>
              </span>
            </div>
          </div>

          <button
            onClick={() => window.location.reload()}
            className="w-full py-3 px-6 bg-medical-600 hover:bg-medical-700 dark:bg-medical-700 dark:hover:bg-medical-600 text-white font-semibold rounded-xl transition-colors duration-200 flex items-center justify-center gap-2"
          >
            <RefreshCw className="w-4 h-4" />
            Check Again
          </button>
        </div>

        <p className="mt-6 text-xs text-slate-400 dark:text-slate-500">
          © {new Date().getFullYear()} American Journal of Modern Medicine. All rights reserved.
        </p>
      </div>
    </div>
  );
};

export default MaintenanceScreen;
